import { useNavigate } from 'react-router-dom';
import { LogOut, Menu, Moon, PanelLeft, ShieldCheck, Sun, User } from 'lucide-react';
import { toast, useAuthStore, useThemeStore } from '@/app/stores';
import { Dropdown } from '@/components/ui/Dropdown';
import { initials } from '@/lib/format';
import { cn } from '@/lib/cn';
import { AllAppsLink } from '@/components/AllAppsLink';
import { usePlatformSession } from './session';

const iconBtn = 'relative grid size-10 place-items-center rounded-lg text-foreground hover:bg-muted';

export function PlatformHeader({ onOpenMenu, onToggleSidebar }: { onOpenMenu: () => void; onToggleSidebar: () => void }) {
  const actor = usePlatformSession((s) => s.actor)!;
  const { logout } = useAuthStore();
  const { mode, toggle } = useThemeStore();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-20 border-b border-border bg-card/90 backdrop-blur-md">
      <div className="flex h-16 items-center gap-2 px-3 sm:gap-3 sm:px-6">
        <button className={cn(iconBtn, 'lg:hidden')} onClick={onOpenMenu} aria-label="Open navigation"><Menu className="size-5" /></button>
        <button className={cn(iconBtn, 'hidden lg:grid')} onClick={onToggleSidebar} aria-label="Collapse or expand sidebar"><PanelLeft className="size-5" /></button>
        <div className="flex min-w-0 flex-1 items-center gap-2 text-sm font-semibold text-muted-foreground">
          <ShieldCheck className="size-4 shrink-0 text-secondary" /><span className="truncate">Platform-wide — every store on MCE</span>
        </div>
        <div className="flex items-center gap-0.5">
          <AllAppsLink />
          <button className={iconBtn} onClick={toggle} aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>{mode === 'dark' ? <Sun className="size-5" /> : <Moon className="size-5" />}</button>
          <Dropdown
            label="Account menu"
            trigger={<span className="flex items-center gap-2 rounded-lg p-1 hover:bg-muted"><span className="grid size-9 place-items-center rounded-full bg-secondary text-sm font-bold text-white">{initials(actor.user.name)}</span><span className="hidden text-left leading-tight lg:block"><span className="block max-w-32 truncate text-sm font-semibold">{actor.user.name}</span><span className="block text-[11px] text-muted-foreground">Platform admin</span></span></span>}
            items={[
              { label: actor.user.email, icon: <User className="size-4" />, onSelect: () => undefined },
              { label: 'Sign out', icon: <LogOut className="size-4" />, danger: true, divider: true, onSelect: async () => { await logout(); usePlatformSession.getState().reset(); toast.info('Signed out'); nav('/login'); } },
            ]}
          />
        </div>
      </div>
    </header>
  );
}
